(() => {
  if (customElements.get('fa-card-gallery')) return;
  const storageKey = 'tp_wl';
  let memory = [];
  const readFavourites = () => {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (Array.isArray(value)) memory = value.map(String);
    } catch (_) {}
    return memory;
  };
  class FoziaCardGallery extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('[data-card-track]');
      this.dots = [...this.querySelectorAll('[data-card-dot]')];
      this.favourite = this.querySelector('[data-card-favourite]');
      this.status = this.querySelector('[data-card-status]');
      this.index = 0;
      this.suppressUntil = 0;
      this.favourite.addEventListener('click', () => this.toggleFavourite(), options);
      window.addEventListener('fa:favourites-change', () => this.syncFavourite(), options);
      window.addEventListener('storage', event => {
        if (event.key === storageKey) this.syncFavourite();
      }, options);
      this.syncFavourite();
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', event => {
          event.stopPropagation();
          this.showImage(index);
        }, options);
        dot.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.dots.length;
          else if (event.key === 'ArrowLeft') next = (index + this.dots.length - 1) % this.dots.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.dots.length - 1;
          else return;
          event.preventDefault();
          this.dots[next].focus({ preventScroll: true });
          this.showImage(next);
        }, options);
      });
      this.track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.setCurrent(Math.round(this.track.scrollLeft / this.track.clientWidth));
        });
      }, { ...options, passive: true });
      this.track.addEventListener('dragstart', event => event.preventDefault(), options);
      this.track.addEventListener('pointerdown', event => {
        if (event.button !== 0) return;
        this.gesture = { x: event.clientX, y: event.clientY, scroll: this.track.scrollLeft, mouse: event.pointerType === 'mouse', moved: false };
      }, options);
      this.track.addEventListener('pointermove', event => {
        if (!this.gesture) return;
        const dx = event.clientX - this.gesture.x;
        const dy = event.clientY - this.gesture.y;
        if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) {
          this.gesture.moved = true;
          if (this.gesture.mouse) {
            event.preventDefault();
            this.track.classList.add('is-dragging');
            this.track.scrollLeft = this.gesture.scroll - dx;
          }
        }
      }, options);
      const finish = () => {
        if (!this.gesture) return;
        if (this.gesture.moved) {
          this.suppressUntil = Date.now() + 350;
          this.track.classList.remove('is-dragging');
          if (this.gesture.mouse) this.showImage(Math.round(this.track.scrollLeft / this.track.clientWidth), false);
        }
        this.gesture = null;
      };
      window.addEventListener('pointerup', finish, options);
      this.track.addEventListener('pointercancel', finish, options);
      this.track.addEventListener('click', event => {
        if (event.detail && Date.now() < this.suppressUntil) {
          event.preventDefault();
          event.stopPropagation();
          this.suppressUntil = 0;
        }
      }, { ...options, capture: true });
      this.resize = new ResizeObserver(() => {
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' });
      });
      this.resize.observe(this.track);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
      this.abort = null;
    }
    showImage(index, announce = true) {
      index = Math.max(0, Math.min(index, this.dots.length - 1));
      if (index < 0) return;
      this.setCurrent(index);
      this.track.scrollTo({ left: index * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      if (announce && this.status) this.status.textContent = this.dots[index].getAttribute('aria-label');
    }
    setCurrent(index) {
      this.index = index;
      this.dots.forEach((dot, current) => {
        dot.setAttribute('aria-pressed', String(current === index));
        dot.tabIndex = current === index ? 0 : -1;
      });
    }
    syncFavourite() {
      const selected = readFavourites().includes(this.dataset.productId);
      this.favourite.setAttribute('aria-pressed', String(selected));
      this.favourite.setAttribute('aria-label', selected ? this.dataset.removeLabel : this.dataset.addLabel);
      this.favourite.classList.toggle('is-favourite', selected);
    }
    toggleFavourite() {
      const list = readFavourites().slice();
      const index = list.indexOf(this.dataset.productId);
      if (index < 0) list.push(this.dataset.productId);
      else list.splice(index, 1);
      memory = list;
      try { localStorage.setItem(storageKey, JSON.stringify(list)); } catch (_) {}
      window.dispatchEvent(new CustomEvent('fa:favourites-change'));
      if (this.status) this.status.textContent = index < 0 ? this.dataset.savedLabel : this.dataset.removedLabel;
    }
  }
  customElements.define('fa-card-gallery', FoziaCardGallery);
})();
